import { createFileRoute } from '@tanstack/react-router'
import { ModuleDetailPage } from '@/features/modules/detail'

export const Route = createFileRoute('/_authenticated/modules/detail/$moduleId' as any)({
	component: ModuleDetailWrapper,
})

function ModuleDetailWrapper() {
	const { moduleId } = (Route as any).useParams() as { moduleId: string }
	return <ModuleDetailPage key={moduleId} />
}

export default Route
